interface IRouteMatchLike {
  loaderData: unknown;
}

interface IWithCategorySlug {
  categorySlug?: string | null;
}

const hasCategorySlug = (data: unknown): data is IWithCategorySlug =>
  typeof data === "object" && data !== null && "categorySlug" in data;

export const getActiveCategorySlug = (
  matches: IRouteMatchLike[]
): string | null => {
  for (let i = matches.length - 1; i >= 0; i--) {
    const { loaderData } = matches[i];

    if (hasCategorySlug(loaderData)) {
      return loaderData.categorySlug ?? null;
    }
  }

  return null;
};
